import { create } from "zustand"
import { createJSONStorage,persist } from "zustand/middleware"

import type { User } from "@/modules/types"

interface AuthState {
  user: User | null
  accessToken: string | null
  refreshToken: string | null
  notificationToken: string | null
  isNewUser: boolean | null
  isIgnoreReferral: boolean | null
  // Actions
  setIsNewUser: (isNewUser: boolean) => void
  setIsIgnoreReferral: (isIgnoreReferral: boolean) => void
  setNotificationToken: (token: string | null) => void
  login: (payload: {
    accessToken: string
    refreshToken: string
    notificationToken?: string | null
    isNewUser?: boolean
  }) => void
  logout: () => void
  setUser: (user: User) => void
  resetAll: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      notificationToken: null,
      isNewUser: null,
      isIgnoreReferral: false,

      setIsNewUser: (isNewUser) => set({ isNewUser }),

      setIsIgnoreReferral: (isIgnoreReferral) => set({ isIgnoreReferral }),

      setNotificationToken: (notificationToken) => set({ notificationToken }),

      login: ({ accessToken, refreshToken, notificationToken, isNewUser }) => {
        set((state) => ({
          accessToken,
          refreshToken,
          notificationToken:
            notificationToken !== undefined ? notificationToken : state.notificationToken,
          isNewUser
        }))
      },

      setUser: (user) => set({ user }),

      logout: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          notificationToken: null
        })
      },

      resetAll: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          notificationToken: null,
          isNewUser: null,
          isIgnoreReferral: false
        })
      }
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => window.localStorage)
    }
  )
)
